export class UserLabelledParkPayloadModel {
  public ParkId: string | null = null
  public LabelId: string | null = null
  public UserId: string | null = null
  public constructor(init?: Partial<UserLabelledParkPayloadModel>) {
    Object.assign(this, init)
  }
}
